import React from 'react';
import socketio from "socket.io-client";

const socketServer = window._app_config.REACT_APP_ROOT_URL || 'localhost:15081'

export const socket = socketio.connect(socketServer);
export const SocketContext = React.createContext();